export default "__VITE_ASSET__c018d415__"